import './MultiInput.css';

import { Input } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const MultiInput = ({
  data,
  length,
  checkIsDigit,
  maxLength,
  onFull,
  dataHandler,
  className,
  disabled,
  placeholder,
  minLength
}) => {
  MultiInput.propTypes = {
    length: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.string,
    dataHandler: PropTypes.func,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onFull: PropTypes.func,
    className: PropTypes.string,
    checkIsDigit: PropTypes.bool
  };

  const [innerData, setInnerData] = useState(data || Array(length));
  const dataRef = useRef([]);

  const ReplaceAt = (index, replacement) => {
    var changed = false;
    var a = [...innerData];
    if (checkIsDigit) {
      a[index] = replacement;
      changed = true;
    } else {
      a[index] = replacement;
      changed = true;
    }
    if (changed && index !== length - 1 && replacement !== '') {
      dataRef.current[index + 1].focus();
    } else if (changed && index > 0 && replacement === '') {
      dataRef.current[index - 1].focus();
    }
    return a;
  };

  useEffect(() => {
    if (
      innerData.length === maxLength &&
      innerData !== ''.repeat(maxLength) &&
      !innerData.includes(' ') &&
      !innerData.includes('')
    ) {
      if (onFull) {
        onFull(innerData.join(''));
      }
    }
    if (dataHandler) {
      dataHandler(innerData.join(''));
    }
  }, [
    innerData,
    data,
    length,
    checkIsDigit,
    maxLength,
    onFull,
    dataHandler,
    className,
    disabled,
    placeholder,
    minLength
  ]);

  return (
    <form className={`multi-input ma-b-80 ${className}`} onSubmit={() => null}>
      {[...Array(length)].map((value, index) => (
        <div key={index} className="multi-input-segment">
          <Input
            key={index}
            ref={(e) => (dataRef.current[index] = e)}
            bordered={false}
            className="multi-input-base"
            disabled={disabled || null}
            inputMode="numeric"
            maxLength={maxLength || null}
            minLength={minLength || null}
            onChange={(e) => setInnerData(ReplaceAt(index, e.target.value))}
            pattern="[0-9]*"
            placeholder={placeholder ? placeholder[index] : null}
            value={innerData[index] ? innerData[index] : ''}
          />
        </div>
      ))}
    </form>
  );
};

export default MultiInput;
